module.exports = __webpack_public_path__ + "img/brand-fritz.20151141.svg";